"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorTermComparatorFactoryExpressionEvaluator = void 0;
const InternalEvaluator_1 = require("@comunica/actor-expression-evaluator-factory-default/lib/InternalEvaluator");
const bus_term_comparator_factory_1 = require("@comunica/bus-term-comparator-factory");
const context_entries_1 = require("@comunica/context-entries");
const core_1 = require("@comunica/core");
const utils_bindings_factory_1 = require("@comunica/utils-bindings-factory");
const Eval = __importStar(require("@comunica/utils-expression-evaluator"));
const TermComparatorExpressionEvaluator_1 = require("./TermComparatorExpressionEvaluator");
/**
 * A comunica Expression Evaluator Based Term Comparator Factory Actor.
 */
class ActorTermComparatorFactoryExpressionEvaluator extends bus_term_comparator_factory_1.ActorTermComparatorFactory {
    async test(_action) {
        return (0, core_1.passTestVoid)();
    }
    /**
     * Context item superTypeProvider can be expected here
     * @param context IActionTermComparatorFactory
     * @param context.context IActionContext
     */
    async run({ context }) {
        context = Eval.prepareEvaluatorActionContext(context);
        return new TermComparatorExpressionEvaluator_1.TermComparatorExpressionEvaluator(new InternalEvaluator_1.InternalEvaluator(context, this.mediatorFunctionFactory, this.mediatorQueryOperation, await utils_bindings_factory_1.BindingsFactory.create(this.mediatorMergeBindingsContext, context, context.getSafe(context_entries_1.KeysInitQuery.dataFactory))), await this.mediatorFunctionFactory
            .mediate({ functionName: Eval.SparqlOperator.EQUAL, context, requireTermExpression: true }), await this.mediatorFunctionFactory
            .mediate({ functionName: Eval.SparqlOperator.LT, context, requireTermExpression: true }));
    }
}
exports.ActorTermComparatorFactoryExpressionEvaluator = ActorTermComparatorFactoryExpressionEvaluator;
//# sourceMappingURL=ActorTermComparatorFactoryExpressionEvaluator.js.map